import React from 'react';
import { MetricsGridProps } from '../types';
import { MetricCard } from '../MetricCard/MetricCard';
import { cn } from '../../../../lib/utils';
import { getThemeClass } from '../../../../lib/theme';

const gridCols = {
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-2 lg:grid-cols-3',
  4: 'md:grid-cols-2 lg:grid-cols-4'
};

const gridSpacing = {
  sm: 'gap-4',
  md: 'gap-6',
  lg: 'gap-8'
};

export const MetricsGrid: React.FC<MetricsGridProps> = ({
  metrics,
  columns = 3,
  spacing = 'md',
  variant = 'light'
}) => {
  return (
    <div className={cn(
      'grid grid-cols-1',
      gridCols[columns],
      gridSpacing[spacing],
      getThemeClass('colors.background.light')
    )}>
      {metrics.map((metric, index) => (
        <MetricCard
          key={index}
          {...metric}
          variant={variant}
          className={cn(
            'transition-all duration-300',
            getThemeClass('colors.border.hover', 'borderHover'),
            metric.className
          )}
        />
      ))}
    </div>
  );
};